import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-verticalLine",
  "use": "icon-verticalLine-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-verticalLine\">\n<rect x=\"87.079\" y=\"22.474\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#8FC31F\" width=\"25.842\" height=\"155.051\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol